module.exports = __webpack_public_path__ + "img/correct--small.95714542.svg";